 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"polyfills-core-js":"polyfills-core-js","polyfills-css-shim":"polyfills-css-shim","polyfills-dom":"polyfills-dom","stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-013061d2":"f1677a9a","chunk-0149e7ec":"976b1dbc","chunk-022a7fbd":"df821c96","chunk-06a7f5c0":"424fb2e4","chunk-09e1e8fb":"8d41c9e0","chunk-0f4297b0":"7cb3b0c2","chunk-1ab29a11":"7b3f2658","chunk-1dc7c1c5":"0bb62163","chunk-1fc2d15c":"c425c19e","chunk-2187c8c2":"707921ec","chunk-26f4df71":"b6065014","chunk-29dcf67c":"a31c3a34","chunk-2b966f81":"2ff793be","chunk-2d0ac931":"17cfa0f8","chunk-2d0ac96a":"3e55fa9d","chunk-2d0af8d9":"24133133","chunk-2d0b991b":"1227235d","chunk-2d0c0a6f":"55058f40","chunk-2d0c20a0":"554097fe","chunk-2d0c211b":"ba545cf5","chunk-2d0cf315":"1ef6206f","chunk-2d0e5796":"4d2886b0","chunk-2d0e60ea":"66178d1a","chunk-2d0e6302":"079a967b","chunk-2d208702":"36ed287c","chunk-2d215cbc":"22febb6c","chunk-2d217def":"b35cd03e","chunk-2d21a9aa":"6003d65f","chunk-2d222cca":"2219326e","chunk-2d225f0d":"e247936f","chunk-2d226d25":"1ab927b0","chunk-2d228901":"cd438176","chunk-2d22895d":"b81bc54f","chunk-2d22bf33":"7310a290","chunk-2d2304d2":"2178b8d3","chunk-2d23721e":"db20ec86","chunk-2d2378b1":"79681eaa","chunk-304e7324":"4a6d458c","chunk-3135c405":"3deea3c4","chunk-32b5152d":"fa3ea66f","chunk-343d842a":"9d8c2f5d","chunk-3582ae12":"51ed16e1","chunk-43ca682a":"adbde41f","chunk-4abc2f07":"2c5b140e","chunk-4da1c3e4":"05467444","chunk-52eabdec":"f758ef1c","chunk-5d875e1a":"23aaf5f3","chunk-5db12fb6":"da384644","chunk-5f259812":"d1b4fb92","chunk-60445926":"8bff8d0f","chunk-63f0a1ff":"0f64bb5f","chunk-659b163e":"4cb7272b","chunk-68d95220":"1a1f2cc5","chunk-6b3808c8":"0fce0efc","chunk-6e1ebba7":"d0495c08","chunk-6f5ed6b2":"21481df7","chunk-7299f250":"e4012114","chunk-778df663":"a6bf585d","chunk-7857c4af":"a8292657","chunk-7885c3cc":"beb9a248","chunk-7db91453":"06e3fb35","chunk-a115bba0":"3adddd33","chunk-adff4748":"63e67454","chunk-c602cac6":"c6f915a1","chunk-cc885ef2":"103761f1","chunk-e0927678":"ba1f8dbf","chunk-e0939ef4":"cd0678d9","chunk-ed897f96":"886117a5","polyfills-core-js":"8da452c8","polyfills-css-shim":"2fd7257a","polyfills-dom":"5c1a31ff","stencil-polyfills-css-shim":"54fc0886","stencil-polyfills-dom":"a351dbf1","chunk-2d23088f":"0ad21ca3","chunk-2d0ac1be":"cfef496e","chunk-2d0c1234":"d98fd805","chunk-2d0ccb9d":"32fabf40","chunk-2d0f0480":"f13756c1","chunk-2d20f346":"6d09b40e","chunk-2d217498":"0c1e6b55"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-29dcf67c":1,"chunk-32b5152d":1,"chunk-43ca682a":1,"chunk-659b163e":1,"chunk-adff4748":1,"chunk-e0939ef4":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"polyfills-core-js":"polyfills-core-js","polyfills-css-shim":"polyfills-css-shim","polyfills-dom":"polyfills-dom","stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-013061d2":"31d6cfe0","chunk-0149e7ec":"31d6cfe0","chunk-022a7fbd":"31d6cfe0","chunk-06a7f5c0":"31d6cfe0","chunk-09e1e8fb":"31d6cfe0","chunk-0f4297b0":"31d6cfe0","chunk-1ab29a11":"31d6cfe0","chunk-1dc7c1c5":"31d6cfe0","chunk-1fc2d15c":"31d6cfe0","chunk-2187c8c2":"31d6cfe0","chunk-26f4df71":"31d6cfe0","chunk-29dcf67c":"1abb7c32","chunk-2b966f81":"31d6cfe0","chunk-2d0ac931":"31d6cfe0","chunk-2d0ac96a":"31d6cfe0","chunk-2d0af8d9":"31d6cfe0","chunk-2d0b991b":"31d6cfe0","chunk-2d0c0a6f":"31d6cfe0","chunk-2d0c20a0":"31d6cfe0","chunk-2d0c211b":"31d6cfe0","chunk-2d0cf315":"31d6cfe0","chunk-2d0e5796":"31d6cfe0","chunk-2d0e60ea":"31d6cfe0","chunk-2d0e6302":"31d6cfe0","chunk-2d208702":"31d6cfe0","chunk-2d215cbc":"31d6cfe0","chunk-2d217def":"31d6cfe0","chunk-2d21a9aa":"31d6cfe0","chunk-2d222cca":"31d6cfe0","chunk-2d225f0d":"31d6cfe0","chunk-2d226d25":"31d6cfe0","chunk-2d228901":"31d6cfe0","chunk-2d22895d":"31d6cfe0","chunk-2d22bf33":"31d6cfe0","chunk-2d2304d2":"31d6cfe0","chunk-2d23721e":"31d6cfe0","chunk-2d2378b1":"31d6cfe0","chunk-304e7324":"31d6cfe0","chunk-3135c405":"31d6cfe0","chunk-32b5152d":"211d1163","chunk-343d842a":"31d6cfe0","chunk-3582ae12":"31d6cfe0","chunk-43ca682a":"fe9acf4a","chunk-4abc2f07":"31d6cfe0","chunk-4da1c3e4":"31d6cfe0","chunk-52eabdec":"31d6cfe0","chunk-5d875e1a":"31d6cfe0","chunk-5db12fb6":"31d6cfe0","chunk-5f259812":"31d6cfe0","chunk-60445926":"31d6cfe0","chunk-63f0a1ff":"31d6cfe0","chunk-659b163e":"b2e97244","chunk-68d95220":"31d6cfe0","chunk-6b3808c8":"31d6cfe0","chunk-6e1ebba7":"31d6cfe0","chunk-6f5ed6b2":"31d6cfe0","chunk-7299f250":"31d6cfe0","chunk-778df663":"31d6cfe0","chunk-7857c4af":"31d6cfe0","chunk-7885c3cc":"31d6cfe0","chunk-7db91453":"31d6cfe0","chunk-a115bba0":"31d6cfe0","chunk-adff4748":"3d99ae43","chunk-c602cac6":"31d6cfe0","chunk-cc885ef2":"31d6cfe0","chunk-e0927678":"31d6cfe0","chunk-e0939ef4":"646216a5","chunk-ed897f96":"31d6cfe0","polyfills-core-js":"31d6cfe0","polyfills-css-shim":"31d6cfe0","polyfills-dom":"31d6cfe0","stencil-polyfills-css-shim":"31d6cfe0","stencil-polyfills-dom":"31d6cfe0","chunk-2d23088f":"31d6cfe0","chunk-2d0ac1be":"31d6cfe0","chunk-2d0c1234":"31d6cfe0","chunk-2d0ccb9d":"31d6cfe0","chunk-2d0f0480":"31d6cfe0","chunk-2d20f346":"31d6cfe0","chunk-2d217498":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
